import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

const initialForm = {
  fullName: "",
  email: "",
  phone: "",
  projectName: "",
  lookingFor: "",
  message: "",
  frmName: "Contact Form",
};

const ContactForm = () => {
  const [contactForm, setContactForm] = useState(initialForm);
  const [errors, setErrors] = useState({});
  const [isContactSubmitting, setIsContactSubmitting] = useState(false);
  const [isContactSubmitted, setIsContactSubmitted] = useState(false);
  const { executeRecaptcha } = useGoogleReCaptcha();

  const handleChange = (e) => {
    setContactForm({ ...contactForm, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" }); // clear error when typing
  };

  const validateForm = () => {
    let newErrors = {};
    if (!contactForm.fullName.trim()) newErrors.fullName = "Full name is required.";
    if (!contactForm.email.trim()) newErrors.email = "Email is required.";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contactForm.email))
      newErrors.email = "Invalid email address.";
    if (!contactForm.message.trim()) newErrors.message = "Message is required.";
    return newErrors;
  };

  const handleContactSubmit = async (e) => {
    e.preventDefault();

    const newErrors = validateForm();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    if (!executeRecaptcha) {
      toast.error("reCAPTCHA not ready");
      return;
    }

    setIsContactSubmitting(true);

    try {
      const recaptchaToken = await executeRecaptcha("contact_submit");
      const response = await axios.post("https://api.rashtechinfo.com/inquiries", {
        ...contactForm,
        recaptchaValue: recaptchaToken,
      });

      if (response.status === 200) {
        setIsContactSubmitted(true);
        setContactForm(initialForm);
        toast.success("Message sent successfully! ✅");
        setTimeout(() => setIsContactSubmitted(false), 4000);
      }
    } catch (error) {
      console.error("Submission failed:", error);
      toast.error("Something went wrong. Please try again.");
    } finally {
      setIsContactSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleContactSubmit} className="">
      <div className="row">
        {/* Full Name */}
        <div className="col-md-6 mb-3">
          <label className="input_title">Full Name</label>
          <input
            type="text"
            name="fullName"
            value={contactForm.fullName}
            onChange={handleChange}
            className={`form-control ${errors.fullName ? "is-invalid" : ""}`}
            placeholder="Enter Your Full Name"
          />
          {errors.fullName && <div className="invalid-feedback">{errors.fullName}</div>}
        </div>

        {/* Email */}
        <div className="col-md-6 mb-3">
          <label className="input_title">Your Email</label>
          <input
            type="email"
            name="email"
            value={contactForm.email}
            onChange={handleChange}
            className={`form-control ${errors.email ? "is-invalid" : ""}`}
            placeholder="Enter Your Email Address"
          />
          {errors.email && <div className="invalid-feedback">{errors.email}</div>}
        </div>

        {/* Phone */}
        <div className="col-md-6 mb-3">
          <label className="input_title">Your Phone</label>
          <input
            type="text"
            name="phone"
            value={contactForm.phone}
            onChange={handleChange}
            className="form-control"
            placeholder="Enter Your Phone Number"
          />
        </div>

        {/* Project Name */}
        <div className="col-md-6 mb-3">
          <label className="input_title">Project Name</label>
          <input
            type="text"
            name="projectName"
            value={contactForm.projectName}
            onChange={handleChange}
            className="form-control"
            placeholder="Your Project Name"
          />
        </div>

        {/* Looking For */}
        <div className="col-12 mb-3">
          <label className="input_title">Looking For</label>
          <select
            name="lookingFor"
            value={contactForm.lookingFor}
            onChange={handleChange}
            className="form-control"
          >
            <option value="">Select Service</option>
            <option value="Web Development">Web Development</option>
            <option value="App Development">App Development</option>
            <option value="E-commerce Solutions">E-commerce Solutions</option>
            <option value="Custom Website">Custom Website</option>
            <option value="UI/UX Design">UI/UX Design</option>
            <option value="Graphic Design">Graphic Design</option>
            <option value="Video Editing">Video Editing</option>
            <option value="SEO Service">SEO Service</option>
            <option value="SMO Service">SMO Service</option>
          </select>
        </div>

        {/* Message */}
        <div className="col-12 mb-3">
          <label className="input_title">Message</label>
          <textarea
            name="message"
            value={contactForm.message}
            onChange={handleChange}
            className={`form-control ${errors.message ? "is-invalid" : ""}`}
            rows="5"
            placeholder="How can we help you?"
          />
          {errors.message && <div className="invalid-feedback">{errors.message}</div>}
        </div>

        {/* Submit Button */}
        <div className="col-12 mt-3">
          <button
            type="submit"
            className="btn btn-primary w-100 py-3"
            disabled={isContactSubmitting}
          >
            {isContactSubmitting ? (
              <span>
                <i className="fa fa-spinner fa-spin"></i> Sending...
              </span>
            ) : (
              <span>
                Send Message <i className="fa-solid fa-arrow-up-right"></i>
              </span>
            )}
          </button>
        </div>
      </div>
    </form>
  );
};

export default ContactForm;
